import * as React from 'react';
import { RootState } from '../../../store/index';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { TreeNodeType, FMTreeGroupData } from '../../../store/FMTree/FMTreeReducer';
import { getNodeData, isGroupExpanded, makeIsNodeSelected, isNodeChecked } from '../../../store/FMTree/FMTReeSelectors';
import {
    GroupOwnProps,
    GroupStateProps,
    GroupProps,
} from '../../organisms/FMTree/TypesForNodes';

const FMTreeGroupNodeWithStore = GroupNode => (props: GroupProps) => {
    let expandGroup = () => props.expandGroupBase(
        props.treeDisplayState,
        props.id
    );

    let collapseGroup = () => props.collapseGroupBase(
        props.treeDisplayState,
        props.id
    );

    let checkNode = () => props.checkNodeBase(
        props.treeType,
        props.treeDisplayState,
        TreeNodeType.group,
        props.id
    );

    let uncheckNode = () => props.uncheckNodeBase(
        props.treeType,
        props.treeDisplayState,
        TreeNodeType.group,
        props.id
    );

    let selectNode = () => props.selectNodeBase(
        props.treeDisplayState,
        TreeNodeType.group,
        props.id
    );

    return (
        <GroupNode
            {...props}
            expandGroup={expandGroup}
            collapseGroup={collapseGroup}
            checkNode={checkNode}
            uncheckNode={uncheckNode}
            selectNode={selectNode}
        />
    );
};

const mapStateToProps = (state: RootState, ownProps: GroupOwnProps): GroupStateProps => {

    const isNodeSelected = makeIsNodeSelected(TreeNodeType.group, ownProps.id);

    return {
        name: getNodeData(state, ownProps.treeType, ownProps.id, TreeNodeType.group).name,
        childGroups: (getNodeData(state, ownProps.treeType, ownProps.id, TreeNodeType.group) as FMTreeGroupData).childGroups,
        childItems: (getNodeData(state, ownProps.treeType, ownProps.id, TreeNodeType.group) as FMTreeGroupData).childItems,
        expanded: isGroupExpanded(state, ownProps.treeDisplayState, ownProps.id),
        checked: isNodeChecked(state, ownProps.treeDisplayState, ownProps.id, TreeNodeType.group),
        selected: isNodeSelected(state, ownProps.treeDisplayState),
        nodeData: getNodeData(state, ownProps.treeType, ownProps.id, TreeNodeType.group),
    };

};

const ConnectedFMTreeGroupNode = compose(
    connect(mapStateToProps),
    FMTreeGroupNodeWithStore
);

export default ConnectedFMTreeGroupNode;
